import { GET_USER_LIST, GET_USER_LIST_FAIL, GET_USER_LIST_SUCCESS } from '../types';

const initState = {
  users: [],
  error: null,
  isLoading: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_USER_LIST: {
      return { ...state, isLoading: true };
    }

    case GET_USER_LIST_SUCCESS: {
      const { payload } = action;

      return { ...state, isLoading: false, users: payload, error: null };
    }

    case GET_USER_LIST_FAIL: {
      const { payload } = action;

      return { ...state, isLoading: false, users: [], error: payload };
    }

    default:
      return state;
  }
};
